import { Component, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { QRCodeSettings, ShortLinkPreviewDto } from "@app/models";
import { ShortLinkService } from "@app/services";
import { NgbActiveModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ClipboardService } from "ngx-clipboard";
import { Observable } from "rxjs";
import { map, take, tap } from "rxjs/operators";

@Component({
  selector: "app-app-preview-modal",
  templateUrl: "./app-preview-modal.component.html",
  styleUrls: ["./app-preview-modal.component.scss"]
})
export class AppPreviewModalComponent implements OnInit {
  @ViewChild("tooltip") public tooltip: NgbTooltip;
  settings: QRCodeSettings;
  title: string;
  qrCodeHtmlUrl: SafeUrl;
  qrCodeHtmlUrl$: Observable<SafeUrl>;
  url: string;
  widgetId: number;
  locationId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private shortLinkSvc: ShortLinkService,
    private clipboardApi: ClipboardService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.qrCodeHtmlUrl$ = this.shortLinkSvc.getCustomWidgetQrCodePreview(this.locationId, this.widgetId).pipe(
      take(1),
      tap((previewDto: ShortLinkPreviewDto) => {
        this.url = previewDto.shortUrl;
      }),
      map((previewDto: ShortLinkPreviewDto) => this.sanitizer.bypassSecurityTrustResourceUrl(previewDto.qrCodeLinkUrl || ""))
    );
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  copyText() {
    this.clipboardApi.copyFromContent(this.url);
    this.tooltip.open();
    setTimeout(() => {
      this.tooltip.close();
    }, 1000);
  }
}
